import React from 'react';
import {
  Collapse as ReactCollapse,
  CollapseProps,
  UnmountClosed,
} from 'react-collapse';

import type { TPAComponentProps } from '@wix/wix-ui-tpa/dist/cssVars/types/types';

import classes from './Collapse.scss';

type ReactCollapseTheme = CollapseProps['theme'];

export interface ICollapseProps extends CollapseProps, TPAComponentProps {
  unmountOnExit?: boolean;
}

export function Collapse(props: ICollapseProps) {
  const { unmountOnExit, ...rest } = props;

  const Component = unmountOnExit ? UnmountClosed : ReactCollapse;

  return <Component theme={classes as ReactCollapseTheme} {...rest} />;
}

Collapse.displayName = 'wui/Collapse';
